import { 
    apiBizGetTaskFinished
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_task_done_list: 'bizTaskDoneMgt/set_task_done_list',
    set_task_done_list_dafault: 'bizTaskDoneMgt/set_task_done_list_dafault',
    set_task_total_page: 'bizTaskDoneMgt/set_task_total_page',
    set_filter_query: 'bizTaskDoneMgt/set_filter_query',
    set_filter_word: 'bizTaskDoneMgt/set_filter_word',
    set_filter_default: 'bizTaskDoneMgt/set_filter_default',
}

// count state 必須是 Object
const state = {
    taskDoneMgtList: [],
    totalPage: 0,
    filterQuery: {},
    filterTotal: 0,
    filterWord: '',
    isDefault: true,
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_TASK_DONE_MGT_LIST: (state) => {
        return state.taskDoneMgtList
    },
    GET_BIZ_TASK_DONE_MGT_TOTAL_PAGE: (state) => {
        return state.totalPage
    },
    GET_BIZ_TASK_DONE_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_TASK_DONE_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterTotal
    },
    GET_BIZ_TASK_DONE_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_TASK_DONE_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizTaskDoneMgtList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_task_done_list, '');
            apiBizGetTaskFinished(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(res.data.result.houseTaskVoList != undefined){
                        commit(types.set_task_done_list, res.data.result.houseTaskVoList);
                        commit(types.set_task_total_page, res.data.result.totalPage);
                    }
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizTaskDoneMgtFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizTaskDoneMgtFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizTaskDoneMgtFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_task_done_list](state, data){
        if(data){
            data.map( item => {
                state.taskDoneMgtList.push(item) 
            })
        }else{
            state.taskDoneMgtList = []
        }
        
    },
    [types.set_task_total_page](state, data){
        state.totalPage = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_default](state){
        state.filterQuery = {
            group: '',
            member: '',
            status: '',
            payway: '',
            bonus: [0, 100000],
        }
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/taskMgt/taskDoneMgt.js